/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { editUserRoles } from './user.edit.role.thunk';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  userRoles: [],
  error: undefined,
};

export const editUserRolesSlice = createSlice({
  name: 'editUserRoles',
  initialState,
  reducers: {
    updateUserRoles(state, action) {
      state.userRoles = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(editUserRoles.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(editUserRoles.fulfilled, (state) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.userRoles = [];
        state.error = undefined;
      })
      .addCase(editUserRoles.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.error = action?.error?.message;
      });
  },
});

/* Selectors */
const selectEditUserRoles = state => state[editUserRolesSlice.name];
export const selectRoles = createSelector(selectEditUserRoles, s => s.userRoles);
export const selectStatus = createSelector(selectEditUserRoles, s => s.status);

/* Actions */
export const { updateUserRoles } = editUserRolesSlice.actions;
